import * as React from 'react';
import { Wave } from '../../wave/types/wave.type';
import { getTagLabel } from '../../wave/utils/tags.utils';
import { useStrip } from '../hooks/useStrip';
import { squareToPixel, TEXT_HEIGHT } from '../utils/graph.utils';
import { StripSquare } from './StripSquare';

interface Props {
  wave: Wave;
}

export const WaveTag: React.FC<Props> = ({ wave }) => {
  const { xScale, onset } = useStrip();
  const xOffset = xScale((wave.offset - wave.onset) / 2 + onset);
  const textOffset = -squareToPixel(1 / 3);

  const label = getTagLabel(wave);

  if (label === '') {
    return null;
  }

  return (
    <StripSquare onset={wave.onset} offset={wave.offset}>
      <g
        style={{
          transform: `translate(${xOffset}px, 100%)`,
          fontSize: TEXT_HEIGHT,
        }}
      >
        <text>|</text>
        <text
          style={{
            transform: `translate(0px, ${textOffset}px) rotate(-45deg)`,
          }}
        >
          {label}
        </text>
      </g>
    </StripSquare>
  );
};
